import { render } from "./AgentView.vue?vue&type=template&id=586ba2d5"
import script from "./AgentView.vue?vue&type=script&lang=js"
export * from "./AgentView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__